<template>
  <p class="text-700 text-slate-400 mt-1">
    <Icon icon="fa-solid fa-gifts" class="text-2xl mr-2" />
    <span class="leading-8">{{ $t('app.contests') }}</span>
  </p>
  <div
    v-for="contest in contests"
    :key="contest.id"
    class="bg-slate-800 p-3 pb-3 pt-1 mt-3 rounded-xl bg-gradient-to-r from-slate-700 cursor-pointer hover:bg-slate-700 relative overflow-hidden"
    @click="
      () => {
        emit('item-click');
        navigateTo(`/contests/${contest.type}`);
      }
    "
  >
    <Icon
      :icon="['fas', 'trophy']"
      class="shadow-2 rounded-xl opacity-10 text-4xl absolute right-0 bottom-0 text-slate-500"
    />
    <div class="flex ml-1">
      <div>
        <p class="z-10 relative text-teal-600 font-bold">
          {{ $t(`contests.${contest.type}_name`) }}
        </p>
        <p class="text-sm z-10 relative">
          {{ $t('app.prize') }}: {{ formatAmount(contest.amount) }}
        </p>
        <p class="text-sm text-slate-400 mt-1">
          {{ $t('app.ends_in') }}
          {{ formatRemainingTime(contest.seconds_left) }}
        </p>
      </div>
    </div>
  </div>
  <CommonSkeleton v-if="loading" :length="2" item-height="4rem" class="mt-3" />
</template>

<script setup>
import moment from 'moment';

const loading = ref(true);
const contests = ref([]);

const api = useApi();

const emit = defineEmits(['item-click']);

onMounted(async () => {
  const response = await api.execute('api/contests');

  contests.value = response;
  loading.value = false;

  // Update remaining time every second
  setInterval(() => {
    contests.value = contests.value.map((contest) => {
      return {
        ...contest,
        seconds_left: Math.max(0, contest.seconds_left - 1),
      };
    });
  }, 1000);
});

const formatRemainingTime = (seconds) => {
  const duration = moment.duration(seconds, 'seconds');

  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const secondsLeft = duration.seconds();

  const formattedTime = [];

  if (days > 0) formattedTime.push(`${days}d`);
  if (hours > 0) formattedTime.push(`${hours}h`);
  if (minutes > 0) formattedTime.push(`${minutes}m`);
  if (secondsLeft > 0) formattedTime.push(`${secondsLeft}s`);

  return formattedTime.join(' ');
};
const formatAmount = (amount) => {
  return amount.toLocaleString(); // Use toLocaleString to add commas
};
</script>
